// Generated by Melange

import * as Buhta_cabinet__SidebarNestedItem from "./SidebarNestedItem.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (currentRoute) {
    return function (setBar) {
      return function (setIsDropdownShown) {
        const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
        const identity = match[0];
        const match$1 = React.useState(function () {
              return false;
            });
        const setIsProfileHovered = match$1[1];
        const isProfileHovered = match$1[0];
        let userpic;
        let exit = 0;
        if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
          exit = 1;
        } else {
          const identityProfile = identity._0;
          userpic = identityProfile.userpic_url === "" ? JsxRuntime.jsx("div", {
                  children: identityProfile.first_name.substring(0, 1),
                  className: "w-5 h-5 rounded-full bg-asphalt flex justify-center items-center text-white text-xs font-semibold"
                }) : JsxRuntime.jsx("img", {
                  className: "w-5 h-5 rounded-50pct",
                  src: identityProfile.userpic_url
                });
        }
        if (exit === 1) {
          userpic = JsxRuntime.jsx("img", {
                className: "w-5 h-5 rounded-50pct",
                src: StaticAsset.src("/static/icons/profile-photo.png")
              });
        }
        let fullName;
        if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
          fullName = "Профиль";
        } else {
          const identityProfile$1 = identity._0;
          fullName = identityProfile$1.first_name + (" " + identityProfile$1.last_name);
        }
        let tmp;
        if (typeof currentRoute === "number" || currentRoute.TAG !== /* Org */6) {
          tmp = false;
        } else {
          let tmp$1 = currentRoute._1;
          tmp = typeof tmp$1 === "number" || tmp$1.TAG !== /* Settings */8 ? false : true;
        }
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/back-arrow.svg")
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                          className: "ml-4 text-white",
                                          children: "Настройки"
                                        })
                                  ],
                                  className: "flex items-center"
                                }),
                            className: Cn.fromList({
                                  hd: "px-6 mt-6 mb-6 flex justify-between",
                                  tl: /* [] */0
                                }),
                            onClick: (function (param) {
                                Curry._1(setBar, (function (param) {
                                        return "main";
                                      }));
                              })
                          }),
                      JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
                            isActive: tmp,
                            route: {
                              TAG: /* Org */6,
                              _0: org.id,
                              _1: {
                                TAG: /* Settings */8,
                                _0: /* General */0
                              }
                            },
                            activeIcon: JsxRuntime.jsx("img", {
                                  className: "w-5 h-5 shrink-0",
                                  src: StaticAsset.src("/static/icons/companies-white.svg")
                                }),
                            icon: JsxRuntime.jsx("img", {
                                  className: "w-5 h-5 shrink-0",
                                  src: StaticAsset.src("/static/icons/companies-dark.svg")
                                }),
                            title: "Общая информация"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("button", {
                                  children: [
                                    userpic,
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: Cn.fromList({
                                                hd: "ml-4 truncate",
                                                tl: {
                                                  hd: isProfileHovered ? "text-white" : "text-gray-medium group-hover:text-white",
                                                  tl: /* [] */0
                                                }
                                              }),
                                          children: fullName
                                        })
                                  ],
                                  className: Cn.fromList({
                                        hd: "whitespace-nowrap px-6 flex py-1.5 hover:w-full",
                                        tl: {
                                          hd: isProfileHovered ? "bg-white/8" : "hover:bg-white/8",
                                          tl: /* [] */0
                                        }
                                      }),
                                  onClick: (function (param) {
                                      Curry._1(setIsDropdownShown, (function (param) {
                                              return true;
                                            }));
                                    }),
                                  onMouseEnter: (function (param) {
                                      Curry._1(setIsProfileHovered, (function (param) {
                                              return true;
                                            }));
                                    }),
                                  onMouseLeave: (function (param) {
                                      Curry._1(setIsProfileHovered, (function (param) {
                                              return false;
                                            }));
                                    })
                                }),
                            className: "absolute bottom-6 space-y-2 w-[244px]"
                          })
                    ]
                  });
      };
    };
  };
}

function SidebarSettings(Props) {
  return Curry._2(make(Props.org)(Props.currentRoute), Props.setBar, Props.setIsDropdownShown);
}

const make$1 = SidebarSettings;

export {
  make$1 as make,
}
/* Buhta_cabinet__SidebarNestedItem Not a pure module */
